import axios from 'axios';
import { eventEmitter } from './eventEmitter.js';

const axiosInstance = axios.create();

// Add request interceptor to include auth headers if available
axiosInstance.interceptors.request.use(
    (config) => {
        // You can add auth headers here if needed
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 401) {
            console.log('Session expired - redirecting to login');
            // Emit unauthorized event to trigger redirect
            eventEmitter.emit('unauthorized');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
